// extracted by mini-css-extract-plugin
export default {"slider__card":"Slider_slider__card__Xj2ug","slider__img":"Slider_slider__img__ypCX-","slider__title":"Slider_slider__title__mo2XJ","slider__desc":"Slider_slider__desc__yDUCQ"};